import React from 'react'
import { any, bool, element, func, oneOfType, string } from 'prop-types'
import { Button, Card, Icon, Menu, Popup } from 'semantic-ui-react'
import css from './Portlet.css'
import { isString, pick } from './Utils'

class PortletEditHeader extends React.PureComponent {
  static propTypes = {
    children: any,
    more: element,
    rightMenuEntry: element
  };
  /**
   * Turn shorthand into the widget or create the widget from the props.
   * @param el
   * @param {Object} rest
   */
  static create(el, rest) {
    let myProps = pick(rest, ['more', 'rightMenuEntry'])

    if (el === null) {
      return <PortletEditHeader {...myProps} />
    }
    if (isString(el)) {
      return (<PortletEditHeader {...myProps}>{el}</PortletEditHeader>)
    }
    return (<PortletEditHeader {...myProps}>{el.props.children}</PortletEditHeader>)
  }

  render() {
    let { children, more, rightMenuEntry } = this.props
    return (
      <PortletHeader more={more} rightMenuEntry={rightMenuEntry}>
        {children}
      </PortletHeader>
    )
  }
}

class PortletHeader extends React.PureComponent {
  static propTypes = {
    children: any,
    info: string,
    more: element,
    rightMenuEntry: element,
    editing: bool
  };

  static defaultProps = {
    editing: false
  };

  /**
   * Turn shorthand into the widget or create the widget from the props.
   * @param el
   * @param {Object} rest
   */
  static create(el, rest) {
    if (el === null) {
      return null
    }
    let myProps = pick(rest, ['info', 'rightMenuEntry', 'more', 'editing'])
    if (isString(el)) {
      return (<PortletHeader {...myProps}>{el}</PortletHeader>)
    }

    return React.cloneElement(el, myProps)
  }

  static LocalizeHeaderKey(s) {
    return `Widgets.${s}`
  }
  static LocalizeInfoKey(s) {
    return s ? `help-docs:DASHBOARD.${s}` : s
  }

  render() {
    let { children, more, rightMenuEntry } = this.props

    return (<Card.Header>
      <Menu fluid className={css['card-header']}>
        <Menu.Item header>
          {children}
        </Menu.Item>
        <Menu.Menu position='right'>{more}</Menu.Menu>
        <Menu.Menu position='right'>{rightMenuEntry}</Menu.Menu>
      </Menu>
    </Card.Header>)
  }
}

class PortletContent extends React.PureComponent {
  static propTypes = {
    children: any
  }

  render() {
    return (<Card.Content className={css['card-main']}>{this.props.children}</Card.Content>)
  }
}

class Portlet extends React.PureComponent {
  static propTypes = {
    children: any,
    onRemove: func,
    editing: bool,
    info: string,
    header: oneOfType([string, element])
  };

  static defaultProps = {
    onRemove: () => { },
    editing: false
  };

  static Header = PortletHeader;
  static Content = PortletContent;

  render() {
    let { onRemove, header, editing, info } = this.props

    let rightMenuEntry = editing
      ? <Menu.Item position='right'><div>
        <Button circular
          icon='close'
          size='mini'
          compact
          onClick={onRemove} />
      </div>
      </Menu.Item>
      : <Menu.Item position='right'>
        {info && info !== '' && (
          <Popup
            trigger={<Icon className='polycom nfo outline large right floated' />}
            content={info}
          />
        )}
      </Menu.Item>

    if (editing) {
      return (<Card fluid className={css.card}>
        {PortletEditHeader.create(header, { ...this.props, rightMenuEntry })}
        <Portlet.Content>{this.props.children}</Portlet.Content>
      </Card>)
    }

    return (<Card fluid className={css.card}>
      {PortletHeader.create(header, { ...this.props, rightMenuEntry })}
      <Portlet.Content>{this.props.children}</Portlet.Content>
    </Card>)
  }
}

export default Portlet
export { PortletHeader, PortletEditHeader }
